import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const AccessibilityOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function AccessibilityOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fillRule="evenodd" clipRule="evenodd" fill="currentColor">
          <path d="M9 3.5c0-1.66 1.34-3 3-3s3 1.34 3 3-1.34 3-3 3-3-1.34-3-3Zm2 0c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1ZM15 9.89v1.85h-.02c0 2.05.29 4.1.87 6.08l1.67 5.68h-2.09l-1.49-5.09v-.03l-.16-.54a1.866 1.866 0 0 0-3.58 0l-.16.54v.03l-.23.77-1.27 4.32H6.45l1.36-4.6.32-1.1c.58-1.97.87-4.01.87-6.06V9.89c-2.41-.17-4.59-.54-6.31-1.1l.62-1.9C5.49 7.59 8.66 8 12 8s6.51-.41 8.69-1.11l.62 1.9c-1.72.56-3.9.93-6.31 1.1Zm-4.2 4.81c.38-.13.79-.2 1.2-.2.41 0 .82.07 1.2.2-.13-.98-.2-1.97-.2-2.96V9.99c-.164 0-.328.003-.493.005-.167.003-.336.005-.507.005-.171 0-.34-.002-.507-.005A32.773 32.773 0 0 0 11 9.99v1.75c0 .99-.07 1.98-.2 2.96Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default AccessibilityOutlined;